import { createEntityAdapter } from '@reduxjs/toolkit';
import IPayrollFunction from 'types/company/payroll/IPayrollFunction';

const functionsAdapter = createEntityAdapter<IPayrollFunction>({
  selectId: f => f.id,
});

export default functionsAdapter;
